// src/pages/ContinueInApp.js
// v5 – clearer web-completion fallback story
//
// Changes vs v4:
// ✅ Reframes this as the post-web-completion continuation path
// ✅ Clarifies app-installed vs install-needed next steps
// ✅ Keeps one clear next action without implying this is the only activation story
// ✅ Reinforces that future sign-in uses the same email/password just created

import React from "react";
import { useLocation } from "react-router-dom";
import QRCode from "react-qr-code";

import { MOBILE_APP_INSTALL_URL } from "../config";
import "../styles/ContinueInApp.css";

const ContinueInApp = () => {
  const location = useLocation();
  const emailFromState = location.state?.email || "";
  const roleFromState = String(location.state?.role || "").toUpperCase();
  const isMobileDevice =
    typeof navigator !== "undefined" &&
    /android|iphone|ipad|ipod/i.test(String(navigator.userAgent || ""));

  const nextStepText =
    roleFromState === "PARENT"
      ? "After signing in, you’ll be asked to add your profile photo before viewing school photos."
      : roleFromState === "PRINCIPAL"
        ? "After signing in, you’ll finish setting up your school."
        : "After signing in, you can continue your GhrianGhraffy setup.";

  return (
    <div className="continue-in-app-page">
      <div className="continue-in-app-shell">
        <section className="continue-in-app-card">
          <div className="continue-in-app-badge">Ready to go</div>

          <h1 className="continue-in-app-title">Your account is ready</h1>

          <p className="continue-in-app-subtitle">
            Open the GhrianGhraffy App on your phone and sign in using the details below.
          </p>

          <div className="continue-in-app-credential-box">
            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Email</div>
              <div className="continue-in-app-credential-value">
                {emailFromState || "Your registered email"}
              </div>
            </div>

            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Password</div>
              <div className="continue-in-app-credential-value">
                The password you just created
              </div>
            </div>
          </div>

          <p className="continue-in-app-note">{nextStepText}</p>

          {isMobileDevice ? (
            <div className="continue-in-app-footer-actions">
              <a
                className="continue-in-app-button primary"
                href={MOBILE_APP_INSTALL_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open install page
              </a>
            </div>
          ) : (
            <>
              <>
                <p className="continue-desktop-hint">
                  You’re on a computer — use your phone to continue.
                </p>

                <p className="continue-choice-helper">
                  Scan this code with your phone camera to open the GhrianGhraffy App install page.
                </p>
              </>

              <div className="continue-in-app-qr-frame">
                <QRCode value={MOBILE_APP_INSTALL_URL} size={150} />
              </div>

              {/* Desktop: QR-only (no clickable install link) */}
            </>
          )}

        </section>
      </div>
    </div>
  );
};

export default ContinueInApp;